<template>
    <div class="index">
        <div class="index-top">
            <div class="logo" @click="goto('/')">
                <div class="picbox">
                    <div class="pic" style="background-image: url(/img/logo.png)"></div>
                </div>
            </div>
            <!-- <a class="login" :href="base.adminLink">
                <div class="picbox">
                    <div class="pic" style="background-image: url(/img/manager.png)"></div>
                </div>
                管理员登录
            </a> -->
        </div>
        <div class="index-center">
            <div class="itemlist">
                <div class="item1" style="background-image: url(/img/index_icon0.png)" @click="createAILink">
                    <div class="txt">
                        <div class="t1">心博士AI</div>
                        <div class="t2">AI心理助手</div>
                    </div>
                </div>
                <div class="item1" style="background-image: url(/img/index_icon1.png)" @click="testOpenPopup">
                    <div class="txt">
                        <div class="t1">量表测评</div>
                        <div class="t2">专业测评 更了解自己</div>
                    </div>
                </div>
                <div class="item2" style="background-image: url(/img/index_icon2.png)"
                    @click="goto('/musicplayer', { id: musics[0].id })">
                    <div class="txt">
                        <div class="t1">心理调适</div>
                        <div class="t2">放松好心情</div>
                    </div>
                </div>
                <div class="item2" style="background-image: url(/img/index_icon3.png)" @click="createGameLink">
                    <div class="txt">
                        <div class="t1">认知训练</div>
                        <div class="t2">解压认知游戏</div>
                    </div>
                </div>
                <div class="item2" style="background-image: url(/img/index_icon4.png)" @click="goto('/mentality')">
                    <div class="txt">
                        <div class="t1">心理科普</div>
                        <div class="t2">了解心理常识</div>
                    </div>
                </div>
                <div class="item3" style="background-image: url(/img/index_icon5.png)" @click="goto('/servicecenter')">
                    <div class="txt">
                        <div class="t1">心理服务中心</div>
                        <div class="t2">走进专业心理团队</div>
                    </div>
                </div>
                <div class="item3" style="background-image: url(/img/index_icon6.png)" @click="goto('/appointment')">
                    <div class="txt">
                        <div class="t1">专家与预约指引</div>
                        <div class="t2">预约指导 方便快捷</div>
                    </div>
                </div>
                <div class="item3" style="background-image: url(/img/index_icon7.png)" @click="goto('/contact')">
                    <div class="txt">
                        <div class="t1">心理社区网点</div>
                        <div class="t2">您身边的心理服务</div>
                    </div>
                </div>
                <div class="item3" style="background-image: url(/img/index_icon8.png)" @click="connectWebrtc()">
                    <div class="txt">
                        <div class="t1">上海市心理热线</div>
                        <div class="t2">24小时电话咨询</div>
                    </div>
                </div>
            </div>
        </div>
        <!-- <div class="index-bottom">
            <div class="double">
                <div class="itemlist">
                    <div class="item">
                        <div class="titlebox"
                            @click="goto('/mentality/mangalist', { cateName: '科普漫画', openKey: 1 })">
                            <div class="atitle">科普漫画</div>
                            <div class="btitle">
                                <div class="picbox">
                                    <div class="pic" style="background-image: url(/img/more.png)"></div>
                                </div>
                            </div>
                        </div>
                        <div class="qalist">
                            <div class="qa-item" v-for="(item, index) in manhua" :key="index">
                                <div class="txt"
                                    @click="goto('/compositionShow', { id: item.id, cateName: '科普漫画' })">{{
                                            item.title
                                    }}</div>
                            </div>
                        </div>
                    </div>
                    <div class="item">
                        <div class="titlebox" @click="goto('/musicplayer', { id: musics[0].id })">
                            <div class="atitle">十分钟冥想</div>
                            <div class="btitle">
                                <div class="picbox">
                                    <div class="pic" style="background-image: url(/img/more.png)"></div>
                                </div>
                            </div>
                        </div>
                        <div class="musiclist">
                            <div class="music" v-for="(item, index) in musics" :key="index"
                                @click="goto('/musicplayer', { id: item.id })">
                                <div class="play">
                                    <div class="picbox">
                                        <div class="pic" style="background-image: url(/img/music_play.png)"></div>
                                    </div>
                                </div>
                                <div class="music-title">
                                    <div class="atitle"><span class="title">{{ item.title }}</span><span class="tag"
                                            v-if="item.categoryTitle">{{ item.categoryTitle }}</span></div>
                                    <div class="btitle">{{ item.author }}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="single">
                <div class="item">
                    <div class="titlebox" @click="goto('/about')">
                        <div class="atitle">普陀悦心亭</div>
                        <div class="btitle">
                            <div class="picbox">
                                <div class="pic" style="background-image: url(/img/more.png)"></div>
                            </div>
                        </div>
                    </div>
                    <div class="introduce" @click="goto('/about')">{{ base.webDesc }}</div>
                    <button class="btn" @click="connectWebrtc()">
                        <div class="icon">
                            <div class="picbox">
                                <div class="pic" style="background-image: url(/img/tel.png)"></div>
                            </div>
                        </div>
                        <div class="txt">心理咨询和预约热线：{{ base.webTel }}</div>
                    </button>
                </div>
            </div>
        </div> -->
        <div class="popup" :class="{ active: telShow }">
            <div class="shadow" @click="telCancel(1)"></div>
            <div class="tel-popup">
                <div class="img">
                    <div class="picbox">
                        <div class="pic" style="background-image: url(/img/popup_tel.png)"></div>
                    </div>
                </div>
                <div class="bottom-box">
                    <div class="txt">
                        <div class="t1">您好，请选择需要拨打的号码？</div>
                    </div>
                    <div class="btns">
                        <button class="btn" @click="ringUp(0)">上海市</button>
                        <button class="btn" @click="ringUp(1)">全国</button>
                    </div>
                </div>
            </div>
        </div>
        <div class="popup" :class="{ active: telConnected }">
            <div class="shadow" @click="telCancel(2)"></div>
            <div class="tel-popup">
                <div class="img">
                    <div class="picbox">
                        <div class="pic" style="background-image: url(/img/popup_tel.png)"></div>
                    </div>
                </div>
                <div class="bottom-box">
                    <div class="txt">
                        <div class="t1">该服务点暂未开通此服务</div>
                    </div>
                    <div class="btns">
                        <button class="btn" @click="telCancel(2)">取消</button>
                    </div>
                </div>
            </div>
        </div>
        <div class="popup" :class="{ active: telRinging }">
            <div class="shadow" @click="telCancel(3)"></div>
            <div class="tel-popup">
                <div class="img">
                    <div class="picbox">
                        <div class="pic" style="background-image: url(/img/popup_tel.png)"></div>
                    </div>
                </div>
                <div class="bottom-box">
                    <div class="txt">
                        <div class="t1">拨号中。。。</div>
                    </div>
                    <div class="btns">
                        <button class="btn" @click="telPopup()">挂断</button>
                    </div>
                </div>
            </div>
        </div>
        <div class="popup" :class="{ active: telActive }">
            <div class="shadow" @click="telCancel(4)"></div>
            <div class="tel-keyboard">
                <div class="img">
                    <div class="picbox">
                        <div class="pic" style="background-image: url(/img/popup_tel.png)"></div>
                    </div>
                </div>
                <div class="bottom-box">
                    <div class="txt">
                        <div class="t1" >
                            {{ keyboardTxt }}
                        </div>
                    </div>
                    <div class="btns">
                        <button class="keyboard" @click="keyboardDown('1')">1</button>
                        <button class="keyboard" @click="keyboardDown('2')">2</button>
                        <button class="keyboard" @click="keyboardDown('3')">3</button>
                    </div>
                    <div class="btns">
                        <button class="keyboard" @click="keyboardDown('4')">4</button>
                        <button class="keyboard" @click="keyboardDown('5')">5</button>
                        <button class="keyboard" @click="keyboardDown('6')">6</button>
                    </div>
                    <div class="btns">
                        <button class="keyboard" @click="keyboardDown('7')">7</button>
                        <button class="keyboard" @click="keyboardDown('8')">8</button>
                        <button class="keyboard" @click="keyboardDown('9')">9</button>
                    </div>
                    <div class="btns">
                        <button class="keyboard" @click="keyboardDown('*')">*</button>
                        <button class="keyboard" @click="keyboardDown('0')">0</button>
                        <button class="keyboard" @click="keyboardDown('#')">#</button>
                    </div>
                    <div class="btns">
                        <button class="btn" @click="telPopup()">挂断</button>
                    </div>
                </div>
            </div>
        </div>
        <div class="popup" :class="{ active: telHangup }">
            <div class="shadow" @click="telCancel(5)"></div>
            <div class="tel-popup">
                <div class="img">
                    <div class="picbox">
                        <div class="pic" style="background-image: url(/img/popup_tel.png)"></div>
                    </div>
                </div>
                <div class="bottom-box">
                    <div class="txt">
                        <div class="t1">通话已结束</div>
                    </div>
                    <div class="btns">
                        <button class="btn" @click="telCancel(5)">退出</button>
                    </div>
                </div>
            </div>
        </div>
        <div class="popup" :class="{ active: testShow }">
            <div class="shadow" @click="testClosePopup"></div>
            <div class="test-popup">
                <div class="tishi">
                    <div class="txt">
                        <div class="t1">请选择您要测评的类型</div>
                        <div class="t2">请从以下测评的分类中，选择一个您适用的量表，然后点击“下一步”填写您的基本信息，进行测评</div>
                    </div>
                    <button class="btn" @click="createTestLink()">下一步</button>
                </div>
                <div class="cardlist">
                    <div class="card" :style="{ backgroundImage: 'url(' + item.bgImage + ')' }" v-for="(item, index) in popupCard"
                        :key="index">
                        <div class="card-main">
                            <div class="img">
                                <div class="picbox">
                                    <div class="pic" :style="{ backgroundImage: 'url(' + item.icon + ')' }"></div>
                                </div>
                            </div>
                            <div class="scalebox">
                                <div class="title">
                                    <div class="atitle">{{ item.atitle }}</div>
                                </div>
                                <div class="scales">
                                    <div v-show="item.radios1" class="scale">
                                        <div class="radio" v-for="(val, k) in item.radios1" :key="k">
                                            <input :id="'radio1' + index + k" type="radio" :value="val.value" v-model="value" />
                                            <label :for="'radio1' + index + k">{{ val.key }}</label>
                                        </div>
                                    </div>
                                    <div v-show="item.radios2" class="scale">
                                        <div class="radio" v-for="(val, k) in item.radios2" :key="k">
                                            <input :id="'radio2' + index + k" type="radio" :value="val.value" v-model="value" />
                                            <label :for="'radio2' + index + k">{{ val.key }}</label>
                                        </div>
                                    </div>
                                    <div v-show="item.radios3" class="scale">
                                        <div class="radio" v-for="(val, k) in item.radios3" :key="k">
                                            <input :id="'radio3' + index + k" type="radio" :value="val.value" v-model="value" />
                                            <label :for="'radio3' + index + k">{{ val.key }}</label>
                                        </div>
                                    </div>
                                    <div v-show="item.radios4" class="scale">
                                        <div class="radio" v-for="(val, k) in item.radios4" :key="k">
                                            <input :id="'radio4' + index + k" type="radio" :value="val.value" v-model="value" />
                                            <label :for="'radio4' + index + k">{{ val.key }}</label>
                                        </div>
                                    </div>
                                    <div v-show="item.radios5" class="scale">
                                        <div class="radio" v-for="(val, k) in item.radios5" :key="k">
                                            <input :id="'radio5' + index + k" type="radio" :value="val.value" v-model="value" />
                                            <label :for="'radio5' + index + k">{{ val.key }}</label>
                                        </div>
                                    </div>
                                    <div v-show="item.radios6" class="scale">
                                        <div class="radio" v-for="(val, k) in item.radios6" :key="k">
                                            <input :id="'radio5' + index + k" type="radio" :value="val.value" v-model="value" />
                                            <label :for="'radio5' + index + k">{{ val.key }}</label>
                                        </div>
                                    </div>
                                    <div v-show="item.radios7" class="scale">
                                        <div class="radio" v-for="(val, k) in item.radios7" :key="k">
                                            <input :id="'radio5' + index + k" type="radio" :value="val.value" v-model="value" />
                                            <label :for="'radio5' + index + k">{{ val.key }}</label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="bg">
                            <div class="picbox">
                                <div class="pic" style="background-image: url(/img/popup_cardbg.png)"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="popup msgbox" :class="{ active: msgShow }">
            <div class="shadow" @click="msgClosePopup()"></div>
            <div class="tel-popup">
                <div class="bottom-box">
                    <div class="txt">
                        <div class="t1">此功能尚未开放，敬请期待！</div>
                    </div>
                    <div class="btns">
                        <button class="btn" @click="msgClosePopup()">知道了</button>
                    </div>
                </div>
            </div>
        </div>
        <video width=800 id="webcam" autoplay="autoplay" hidden="true"></video>
        <el-dialog
            title="心博士AI"
            v-model="AIDialogVisible"
            width="80%"
            height="100%"
            :before-close="onAIContactClose"
            >
            <iframe id="contactFrame" allow="microphone; camera" frameborder="0" width="100%" height="600px" scrolling="no"></iframe>
        </el-dialog>
        <div class="popup msgbox" :class="{ active: AIDialogCloseTypeVisible }">
            <!-- <div class="shadow" @click="msgClosePopup()"></div> -->
            <div class="tel-popup">
                <div class="bottom-box">
                    <div class="txt">
                        <div class="t1">请选择退出方式！</div>
                    </div>
                    <div class="btns">
                        <button class="btn" @click="onAIContactCloseTypeClose(false)">直接关闭</button>
                        <button class="btn" @click="onAIContactCloseTypeClose(true)">关闭并退出账号</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { getBase, getUserInfo, getWebrtcParams, getInfo, getXlctCurrentUserInfo } from "@/js/request";
import { getMangaList2 } from "@/js/request";
import { getMusicList } from "@/js/request";
import { getGame } from "@/js/request";
import { getAI } from "@/js/request";
import { ElMessage } from 'element-plus'
import { loginVerto, doCall, decline, logout, keyboardClick } from '../js/verto.js'



// @ is an alias to /src
export default {
    name: 'Index',
    components: {
    },
    data() {
        return {
            base: {},
            manhua: [],
            musics: [],
            msgShow: false,
            telShow: false,
            telConnected: false,
            telRinging: false,
            telActive: false,
            telHangup: false,
            testShow: false,
            popupCard: [
                {
                    bgImage: '/img/scale1_bg.png', icon: '/img/popup_icon1.png', atitle: '儿童及青少年测评', value: '',
                    radios1: [
                        {key:'儿童社交焦虑量表',value:'YXT_SASC'}, 
                        {key:'艾森克人格问卷（少年版）',value:'YXT_EPQC'}, 
                        {key:'考试焦虑量表',value:'YXT_TAS'}, 
                    ],
                    radios2: [
                        {key:'儿童青少年压力量表',value:'YXT_CASS'},
                        {key:'Rutter儿童行为问卷（父母）',value:'YXT_RCBSP'},
                        {key:'中国中学生心理健康量表',value:'YXT_MSSMHS'},
                    ],
                    radios3: [
                        {key:'儿童抑郁量表',value:'YXT_CDI'},
                        {key:'儿童焦虑性情绪障碍筛查量表',value:'YXT_SCARED'},
                        {key:'Cleveland青少年嗜睡问卷',value:'YXT_CASQ'},
                    ],
                    radios4: [
                        {key:'认知情绪调节量表',value:'YXT_CERQ'},
                        {key:'青少年学习倦怠量表',value:'YXT_ASBI'},
                        {key:'学习方法测验',value:'YXT_TML'},
                    ],
                    radios5: [
                        {key:'学习时间管理',value:'YXT_LTM'},
                        {key:'中学生学习动机量表',value:'YXT_MSMT'},
                        {key:'中学生在校适应能力测试',value:'YXT_SYNL'},
                    ],
                    radios6: [
                        {key:'中学生考试心理和行为问题症状自评量表',value:'YXT_EMP'},
                        {key:'中学生自我导向学习倾向性量表',value:'YXT_SDLRS'},
                        {key:'青少年手机使用依赖自评问卷',value:'YXT_SQAPMPU'},
                    ],
                    radios7: [
                        {key:'青少年上网成瘾自评量表',value:'YXT_AQAP'},
                    ],
                },
                {
                    bgImage: '/img/scale2_bg.png', icon: '/img/popup_icon2.png', atitle: '成年人心理测评', value: '',
                    radios1: [
                        {key:'爱丁堡产后抑郁量表',value:'YXT_EPDS'}, 
                        {key:'宗(Zung)氏抑郁自评量表',value:'YXT_SDS'}, 
                        {key:'宗(Zung)氏焦虑自评量表',value:'YXT_SAS'},
                    ],
                    radios2: [
                        {key:'蒙哥马利抑郁评定量表',value:'YXT_MADRS'},
                        {key:'患者健康问卷焦虑分量表',value:'YXT_GAD-7'}, 
                        {key:'患者健康问卷抑郁筛查',value:'YXT_PHQ-9'}, 
                    ],
                    radios3: [
                        {key:'Locke-Wallace婚姻调适评定',value:'YXT_LWM'}, 
                        {key:'压力知觉量表',value:'YXT_CPSS'},
                        {key:'大五人格问卷简版',value:'YXT_NEO'}
                    ],
                    radios4: [
                        {key:'艾森克人格问卷简式量表',value:'YXT_EPQ-RSC'}
                    ],
                },
                {
                    bgImage: '/img/scale3_bg.png', icon: '/img/popup_icon3.png', atitle: '老年人心理测评', value: '',
                    radios1: [
                        {key:'老年抑郁量表',value:'YXT_GDS'}, 
                        {key:'UCLA孤独量表',value:'YXT_UCLAO'}, 
                        {key:'匹兹堡睡眠质量指数',value:'YXT_PSQI'}
                    ],
                    radios2: [
                        {key:'心境障碍问卷',value:'YXT_MDQ'}
                    ],
                    radios3: [
                    ]
                }
            ],
            value: '',
            vertoExto: 0,
            vertoAgentPwd: '', 
            vertoSerIp: '', 
            vertoSerPort: 0,
            callPhoneNumber: '',
            keyboardTxt: '',
            gameId: 0,
            AIId: 0,
            AIDialogVisible: true,
            AIDialogCloseTypeVisible: false,
            closeDone: null, // 保存 before-close 的 done 回调
        }
    },
    methods: {
        goto(adress, cate) {
            this.$router.push({ path: adress, query: cate });
        },
        telCancel(cancelType) {
            if(cancelType == 1){
                this.telShow = false;
            }else if(cancelType == 2){
                this.telConnected = false;
            }else if(cancelType == 3){
                this.telRinging = false;
            }else if(cancelType == 4){
                this.telActive = false;
            }else if(cancelType == 5){
                this.telHangup = false;
            }
            logout();
        },
        connectWebrtc() {
            const webrtcId = window.localStorage.getItem('webrtcId');
            let webrtcIndex = window.localStorage.getItem('webrtcIndex');
            // 增加点击事件
            getInfo(webrtcId).then(res => {
                console.log("res=", res)
            });
            if(webrtcId == null || webrtcId == undefined || webrtcId == "" ||
                webrtcIndex == null || webrtcIndex == undefined || webrtcIndex == ""){
                this.telShow = false;
                this.telConnected = true;
                return;
            }
            console.log("webrtcIndex2", webrtcIndex);
            webrtcIndex = webrtcIndex.split("?")[0];
            console.log("webrtcIndex3", webrtcIndex);
            
            getWebrtcParams(webrtcId).then(res => {
                const webrtcParams = res.data;
                if(webrtcParams == null || webrtcParams == undefined || webrtcParams.articleFields == null){
                    this.telConnected = true;
                    return;
                }
                this.vertoExto = webrtcParams.articleFields[0].fieldValue;
                this.vertoAgentPwd = webrtcParams.articleFields[1].fieldValue;
                this.vertoSerIp = webrtcParams.articleFields[2].fieldValue;
                this.vertoSerPort = webrtcParams.articleFields[3].fieldValue;
                this.callPhoneNumber = webrtcParams.articleFields[4].fieldValue;
                loginVerto(this.vertoExto, this.vertoAgentPwd, this.vertoSerIp, this.vertoSerPort, 
                    ()=>{
                        logout();
                        this.telShow = true;
                        this.telHangup = false;
                        this.telConnected = false;
                        this.telRinging = false;
                    }, 
                    ()=>{
                        logout();
                        this.telHangup = true;
                        this.telShow = false;
                        this.telConnected = false;
                        this.telRinging = false;
                    }
                );
            });
        },
        ringUp(type) {
            if(type == 1){
                this.callPhoneNumber = '12356';
            }
            console.log('this.callPhoneNumber=', this.callPhoneNumber)
            doCall(this.vertoExto, this.callPhoneNumber,
                ()=>{
                    this.telRinging = true;
                    this.telActive = false;
                    this.telHangup = false;
                    this.telShow = false;
                    this.telConnected = false;
                },
                ()=>{
                    this.telActive = true;
                    this.telRinging = false;
                    this.telHangup = false;
                    this.telShow = false;
                    this.telConnected = false;
                });
        },
        telPopup(){
            this.keyboardTxt = "";
            decline();
            logout();
            this.telHangup = true;
            this.telActive = false;
            this.telShow = false;
            this.telConnected = false;
            this.telRinging = false;
        },
        testOpenPopup() {
            this.testShow = true;
        },
        testClosePopup() {
            this.testShow = false;
        },
        keyboardDown(keyboardNum) {
            this.keyboardTxt += keyboardNum;
            keyboardClick(keyboardNum);
        },
        createTestLink() {
            console.log("this.value",this.value)
            if(this.value==''){
                ElMessage({
                    message: "请选择您要测评的项目",
                    type: 'warning',
                })
                return;
            }
            getUserInfo(this.value).then(res => {
                const webrtcId = window.localStorage.getItem('webrtcId');
                let webrtcIndex = window.localStorage.getItem('webrtcIndex');
                if(webrtcId == null || webrtcId == undefined || webrtcId == "" ||
                    webrtcIndex == null || webrtcIndex == undefined || webrtcIndex == ""){
                    const depId = 3;
                    const jumpJrl = res.data.url + "&depId=" + depId;
                    console.log("jumpJrl=", jumpJrl)
                    window.location.href = jumpJrl;
                }else{
                    webrtcIndex = webrtcIndex.split("?")[0];
                    
                    getWebrtcParams(webrtcId).then(WebrtcRes => {
                        const webrtcParams = WebrtcRes.data;
                        if(webrtcParams == null || webrtcParams == undefined || webrtcParams.articleFields == null){
                            this.telConnected = true;
                            return;
                        }
                        const depId = webrtcParams.articleFields[5].fieldValue;
                        const jumpJrl = res.data.url + "&depId=" + depId;
                        console.log("jumpJrl=", jumpJrl)
                        window.location.href = jumpJrl;
                    });
                }
            }).catch(err => {
                if (err.response) {
                    if (err.response.status == 401) {
                        window.localStorage.setItem('type', 'TEST');
                        window.localStorage.setItem('modelKey', this.value);                 
                        this.$router.push('/home?value='+encodeURIComponent(this.value));
                    } else {
                        alert(err.response.statusText);
                    }
                } else {
                    // 完全没有响应（网络断开、CORS、超时）
                    alert(err.message || '网络错误');
                }
            });
            // 每次登录都需要输入新账号
            // this.$router.push('/home?value='+encodeURIComponent(this.value));
        },
        getGameId(){
            getGame().then(res => {
                this.gameId = res.data[0].id;
            });
        },
        getAIId(){
            getAI().then(res => {
                this.AIId = res.data[0].id;
            });
        },
        async createGameLink() {
            // 增加点击事件
            getInfo(this.gameId).then(res => {
                console.log("getInfores=", res)
            });
            let depId = 3;
            const webrtcId = window.localStorage.getItem('webrtcId');
            let webrtcIndex = window.localStorage.getItem('webrtcIndex');
            if(webrtcId == null || webrtcId == undefined || webrtcId == "" ||
                webrtcIndex == null || webrtcIndex == undefined || webrtcIndex == ""){
                depId = 3;
            }else{
                webrtcIndex = webrtcIndex.split("?")[0];
                
                getWebrtcParams(webrtcId).then(WebrtcRes => {
                    const webrtcParams = WebrtcRes.data;
                    if(webrtcParams == null || webrtcParams == undefined || webrtcParams.articleFields == null){
                        this.telConnected = true;
                        return;
                    }
                    depId = webrtcParams.articleFields[5].fieldValue;
                });
            }
            let target = 'RZPG_TO';
            const jumpBaseUrl = process.env.VUE_APP_GAME_URL;
            await getXlctCurrentUserInfo(depId, target).then(res => {
                console.log('res=',res)
                let jumpUrl = jumpBaseUrl + "&sec=" + res.data.sec;
                window.location.href = jumpUrl;
            }).catch(err => {
                console.log('请求失败:', err);
                if (err.response) {
                    // 服务器有响应，但状态码非 2xx
                    if (err.response.status === 401) {
                        window.localStorage.setItem('type', 'JUMP');
                        window.localStorage.setItem('target', target);
                        window.localStorage.setItem('jumpBaseUrl', jumpBaseUrl);
                        this.$router.push('/home');
                    } else {
                        alert(err.response.statusText || '请求失败');
                    }
                } else {
                    // 完全没有响应（网络断开、CORS、超时）
                    alert(err.message || '网络错误');
                }
            });
            // 每次登录都需要输入新账号
            // this.$router.push('/home?value='+encodeURIComponent(this.value));
        },
        async createAILink() {
            // 增加点击事件 TODO
            getInfo(this.AIId).then(res => {
                console.log("getInfores=", res)
            });
            let depId = 3;
            const webrtcId = window.localStorage.getItem('webrtcId');
            let webrtcIndex = window.localStorage.getItem('webrtcIndex');
            if(webrtcId == null || webrtcId == undefined || webrtcId == "" ||
                webrtcIndex == null || webrtcIndex == undefined || webrtcIndex == ""){
                depId = 3;
            }else{
                webrtcIndex = webrtcIndex.split("?")[0];
                
                getWebrtcParams(webrtcId).then(WebrtcRes => {
                    const webrtcParams = WebrtcRes.data;
                    if(webrtcParams == null || webrtcParams == undefined || webrtcParams.articleFields == null){
                        this.telConnected = true;
                        return;
                    }
                    depId = webrtcParams.articleFields[5].fieldValue;
                });
            }
            let target = 'AI_TO';
            const jumpBaseUrl = process.env.VUE_APP_AI_URL;
            await getXlctCurrentUserInfo(depId, target).then(res => {
                console.log('res=',res)
                let targetUrl = jumpBaseUrl.split('target=')[1];
                this.openAIContact(targetUrl);
            }).catch(err => {
                console.log('请求失败:', err);
                if (err.response) {
                    // 服务器有响应，但状态码非 2xx
                    if (err.response.status === 401) {
                        window.localStorage.setItem('type', 'JUMP');
                        window.localStorage.setItem('target', target);
                        window.localStorage.setItem('jumpBaseUrl', jumpBaseUrl);
                        this.$router.push('/home');
                    } else {
                        alert(err.response.statusText || '请求失败');
                    }
                } else {
                    // 完全没有响应（网络断开、CORS、超时）
                    alert(err.message || '网络错误');
                }
            });
            // 每次登录都需要输入新账号
            // this.$router.push('/home?value='+encodeURIComponent(this.value));
        },
        openAIContact(contactUrl) {
            this.AIDialogVisible = true;
            document.getElementById("contactFrame").src = contactUrl;
        },
        onAIContactClose(done){
            // 先阻止直接关闭，弹出二次确认弹窗
            this.closeDone = done;
            this.AIDialogCloseTypeVisible = true;
        },
        onAIContactCloseTypeClose(exitAccount){
            this.AIDialogCloseTypeVisible = false;

            if (exitAccount) {
                // 关闭并退出账号
                this.$cookies.remove("token");
                console.log("退出账号");
            }

            if (this.closeDone) {
                this.closeDone(); // 真正关闭 dialog
                this.closeDone = null;
            }
        },

        msgOpenPopup() {
            this.msgShow = true;
        },
        msgClosePopup() {
            this.msgShow = false;
        },
        
    },
    mounted() {
        this.AIDialogVisible = false;
        this.$root.showRight();
        if (this.$route.query.wen == 1) {
            this.testShow = true;
        }
        getBase().then(res => {
            this.base = res.data;
        });
        getMangaList2().then(res => {
            this.manhua = res.data;
        });
        getMusicList().then(res => {
            this.musics = res.data;
        });
        this.getGameId();
        this.getAIId();

        this.$nextTick(() => {
            if (this.$route.query.target) {
                // 拿到原始 location.hash
                const hash = window.location.hash  // "#/index?target=https://...&token=xxx"
                // 取出 "target=" 后的内容
                let targetUrl = hash.split('target=')[1]  // "target=https://...&token=xxx"

                this.openAIContact(targetUrl);
                this.$router.replace({
                    path: this.$route.path, // 保留当前路由路径
                    query: {}               // 清空参数
                });
            }
        });
    }
    

}
</script>

<style lang="scss">
.el-dialog__title {
  font-weight: bold;
}
.index {
    width: 1400px;
    margin: 0 auto;
    padding: 5vh 0;
    box-sizing: border-box;
    max-height: 100vh;

    .index-top {
        @include sys-flex(space-between, row);
        margin-bottom: 2vh;

        .logo {
            @include sys-picbox(438px, 80px);
            cursor: pointer;
        }

        .login {
            @include sys-flex(center, row);
            @include sys-boxsize(240px, 60px, 10px, #F6F8FF);
            @include sys-font(20px, $acolor);
            @include sys-picbox(17px, 20px);
            cursor: pointer;

            .picbox {
                margin-right: 10px;
            }
        }
    }

    .index-center {
        display: flex;
        margin-bottom: 10vh;

        .itemlist .item1, .item2, .item3 {
            cursor: pointer;

            .icon {
                transition: transform .8s;
            }
        }

        .itemlist {
            @include sys-flex(space-between, column);
            flex-wrap: wrap;
            flex: 1;
            height: 80vh;

            .item1, .item2, .item3 {
                display: flex;
                align-items: center;
                background-size: cover;
                border-radius: 24px;
                margin-top: 2vh;
                padding: 20px 50px;
                box-sizing: border-box;
                text-align: center;
                position: relative;

                .txt {
                    width: 100%;
                    position: relative;
                    z-index: 5;

                    .t1 {
                        @include sys-text-hide(1);
                        @include sys-font(36px, #fff, bold);
                        line-height: 46px;
                    }

                    .t2 {
                        @include sys-text-hide(2);
                        @include sys-font(20px, #fff);
                        line-height: 30px;
                    }
                }
            }
            .item1{
                width: 510px;
                height: calc((80vh - 4vh) / 2);
            }
            .item2{
                width: 370px;
                height: calc((80vh - 6vh) / 3);
            }
            .item3{
                width: 440px;
                height: calc((80vh - 8vh) / 4);
            }
        }
    }

    .popup {
        position: fixed;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        z-index: 999;
        opacity: 0;
        visibility: hidden;
        &.msgbox{
            .tel-popup .txt{
                padding: 60px 60px 34px;
            }
            position: fixed;       // 脱离文档流，固定在屏幕
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            z-index: 3000;         // 确保比 el-dialog 高
            display: none;         // 默认隐藏
            &.active {
                display: flex;       // 显示时变成弹窗
                align-items: center;
                justify-content: center;
            }
        }
        &.active {
            opacity: 1;
            visibility: visible;
        }

        .shadow {
            width: 100%;
            height: 100%;
            background: rgba(0, 0, 0, .8);
        }

        .tel-popup {
            @include sys-flex();
            width: 450px;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);

            .img {
                @include sys-picbox(192px, 193px);
                margin-bottom: -110px;
                position: relative;
                z-index: 5;
            }

            .bottom-box {
                width: 450px;
                
                .txt {
                    @include sys-font(24px, #000);
                    line-height: 34px;
                    width: 100%;
                    padding: 106px 60px 34px;
                    box-sizing: border-box;
                    background: linear-gradient(
                        180deg, 
                        rgba(#999bfdd3,0.8) 0%, 
                        rgba(#FFFFFF,1) 40%, 
                        rgba(#FFFFFF,1) 100%
                    );
                    border-radius: 16px 16px 0 0;
                }
    
                .btns {
                    width: 100%;
                    height: 80px;
                    display: flex;
    
                    .btn {
                        @include sys-flex();
                        flex: 1;
                        height: 100%;
                        font-size: 24px;
                        cursor: pointer;
    
                        &:first-child {
                            background: #F6F6F6;
                            border-bottom-left-radius: 20px;
                            color: #666;
                        }
    
                        &:last-child {
                            background: $acolor;
                            border-bottom-right-radius: 20px;
                            color: #fff;
                        }
                    }
                }
            }

        }
        .tel-keyboard {
            @include sys-flex();
            width: 450px;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);

            .img {
                @include sys-picbox(192px, 193px);
                margin-bottom: -110px;
                position: relative;
                z-index: 5;
            }

            .bottom-box {
                width: 450px;
                background: #FFFFFF;
                border-radius: 24px 24px 24px 24px;
                .txt {
                    @include sys-font(24px, #000);
                    line-height: 34px;
                    width: 100%;
                    padding: 106px 60px 34px;
                    box-sizing: border-box;
                    background: linear-gradient(
                        180deg, 
                        rgba(#999bfdd3,0.8) 0%, 
                        rgba(#FFFFFF,1) 40%, 
                        rgba(#FFFFFF,1) 100%
                    );
                    border-radius: 16px 16px 0 0;
                }
    
                .btns {
                    width: 100%;
                    height: 80px;
                    display: flex;
    
                    .keyboard {
                        @include sys-flex();
                        flex: 1;
                        height: 100%;
                        font-size: 24px;
                        cursor: pointer;
                        border: 2px solid #fff;
    
                        background: #F6F6F6;
                        color: #666;
                    }
    
                    .btn {
                        @include sys-flex();
                        flex: 1;
                        height: 100%;
                        font-size: 24px;
                        cursor: pointer;
    
                        &:first-child {
                            background: #F6F6F6;
                            border-bottom-left-radius: 20px;
                            color: #666;
                        }
    
                        &:last-child {
                            background: $acolor;
                            border-bottom-right-radius: 20px;
                            color: #fff;
                        }
                    }
                }
            }
        }

        .test-popup {
            width: 1450px;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);

            .tishi {
                @include sys-flex(space-between, row);
                margin-bottom: 30px;

                .txt {
                    max-width: 900px;

                    .t1 {
                        @include sys-text-hide(1);
                        @include sys-font(42px, #F6F8FF, bold);
                        margin-bottom: 20px;
                    }

                    .t2 {
                        @include sys-text-hide(2);
                        @include sys-font(28px, #F6F8FF);
                    }
                }

                .btn {
                    @include sys-radius-btn(180px, 60px, transparent);
                    border: 2px solid #fff;
                    font-size: 24px;
                    font-weight: bold;
                }
            }

            .cardlist {
                @include sys-flex(space-between);

                background: rgba(255,255,255,0.3);
                border-radius: 12px 12px 12px 12px;
                border: 2px solid #FFFFFF;

                .card {
                    @include sys-boxsize(100%, 174px, 12px);
                    // padding: 50px 30px 50px 80px;
                    margin-bottom: 20px;
                    box-sizing: border-box;
                    width: 98%;
                    overflow: hidden;
                    // position: relative;
                    background-size: cover;
                    background-position: right center;

                    &:first-child {
                        margin-top: 20px;
                    }

                    &:last-child {
                        margin-bottom: 20px;
                    }

                    .card-main {
                        height: 100%;
                        display: flex;
                        position: relative;
                        z-index: 5;

                        .img {
                            width: 78px;
                            height: 100%;
                            @include sys-picbox(100%, 100%);
                        }

                        .scalebox{
                            margin-top: 20px;
                            display: flex;
                            flex-direction: column;
                            width: 100%;
                            .title {
                                @include sys-font(28px, #fff);
                                margin-left: 30px;
                                flex: 1;
    
                                .atitle {
                                    font-weight: bold;
                                }
                            }
    
                            .scales {
                                @include sys-flex(space-between);
                                flex-wrap: nowrap;      // 不换行
                                overflow-y: auto;       // 开启纵向滚动
                                overflow-x: hidden;     // 隐藏横向滚动
                                max-height: 100%;       // 限制容器高度（需要指定，否则不会触发滚动条）
        
                                    &::-webkit-scrollbar {
                                        width: 10px;
                                    }
        
                                    &::-webkit-scrollbar-thumb {
                                        background: $acolor;
                                        border-radius: 20px;
                                    }
        
                                    &::-webkit-scrollbar-resizer {
                                        background: $acolor;
                                    }
        
                                    &::-webkit-scrollbar-track-piece {
                                        background: #fff;
                                        border-radius: 20px;
                                    }

                                .scale {
                                    @include sys-flex(flex-start);
                                    flex-wrap: wrap;
                                    align-items: flex-start;    // 子元素靠左对齐
                                    width: 100%;
                                    height: 33%;
                                    flex: 0 0 auto;         // 保证每个元素高度固定，不会被压缩
        
                                    .radio {
                                        width: 33%;
                                        height: 100%!important;
                                        display: flex;
                                        margin-left: 20px;
                                        align-items: center;
                                        overflow: hidden;
                                        @include sys-font(20px, #F6F8FF);
        
                                        label {
                                            // @include sys-text-hide(1);
                                            overflow: visible;
                                            position: relative;
                                            cursor: pointer;
        
                                            &::before {
                                                content: '';
                                                position: absolute;
                                                top: 50%;
                                                left: -40px;
                                                @include sys-flex(center, row);
                                                width: 20px;
                                                height: 20px;
                                                background: rgba(0, 0, 0, .15);
	                                            color: #ffffff;
                                                transform: translateY(-50%);
                                                box-sizing: border-box;
                                            }
                                        }
        
                                        input:checked+label::before {
                                            background: url(../assets/img/popup_radio.png) no-repeat center center/contain;
                                            border: none;
                                        }
        
                                        input {
                                            @include sys-radius-btn(20px, 20px, #F8FAFE);
                                            border: 2px solid #BCC3D8;
                                            margin-right: 20px;
                                            opacity: 0;
                                            pointer-events: none;
                                        }
                                    }
                                }
                            }
                        }
                    }

                    .bg {
                        position: absolute;
                        bottom: 0;
                        right: 4px;
                        width: 235px;
                        height: 160px;
                        @include sys-picbox(100%, 100%);
                    }
                }
                .card:hover {
                    .card-main{
                        .input{
                            overflow: auto;
                        }
                    }
                }
            }
        }
    }
}
</style>